var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$root.$emit('load-more', {})}}},[_vm._v(" "+_vm._s(_vm.btn_loadmore)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }